import { render, staticRenderFns } from "./ProfessorsView.vue?vue&type=template&id=5905db9d"
import script from "./ProfessorsView.vue?vue&type=script&lang=js"
export * from "./ProfessorsView.vue?vue&type=script&lang=js"
import style0 from "./ProfessorsView.vue?vue&type=style&index=0&id=5905db9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports